_getUserHiddenContent